import React, { useEffect, useState } from "react";

const API_BASE = process.env.REACT_APP_API_URL || "";

function buildUrl(path) {
  return `${API_BASE.replace(/\/$/, "")}${path}`;
}

function imageSrc(path) {
  if (!path) return "";
  const p = String(path).trim();
  if (typeof window !== "undefined" && p.startsWith("/uploads/")) {
    return window.location.origin + (p.startsWith("/") ? p : "/" + p);
  }
  if (p.startsWith("http://") || p.startsWith("https://")) return p;
  if (typeof window !== "undefined") {
    return window.location.origin + (p.startsWith("/") ? p : "/" + p);
  }
  return p;
}

const CATEGORY_LABELS = {
  "travel-with-dinesh": "Travel with dinesh",
  "ape-pansala": "Ape pansala",
  urumaya: "Urumaya",
  "ranga-rata": "Ranga Rata",
};

const CategoryOne = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [playingId, setPlayingId] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetch(buildUrl("/api/videos?limit=4"))
      .then((res) => res.json())
      .then((data) => {
        if (!cancelled && data.success && Array.isArray(data.videos)) {
          setVideos(data.videos.slice(0, 4));
        }
      })
      .catch(() => {
        if (!cancelled) setVideos([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  const getVideoSrc = (url) => {
    if (!url) return "";
    if (typeof window !== "undefined" && url.startsWith("/uploads/videos/")) {
      return window.location.origin + url;
    }
    return url;
  };

  const categoryLabel = (slug) => CATEGORY_LABELS[slug] || slug;

  return (
    <section
      className="category-area bg-top-center latest-videos-creative"
      style={{
        backgroundImage: "url(/assets/img/bg/category_bg_1.png)",
        backgroundRepeat: "no-repeat",
        marginTop: "80px",
      }}
    >
      <div className="container th-container">
        <div className="title-area text-center">
          <span className="sub-title">Watch & Explore</span>
          <h2 className="sec-title">Latest Videos</h2>
        </div>

        {loading ? (
          <div className="text-center py-5">
            <p className="sec-title" style={{ fontSize: "1rem", color: "#9ca3af" }}>Loading videos…</p>
          </div>
        ) : videos.length === 0 ? (
          <div className="text-center py-5">
            <p className="sec-title" style={{ fontSize: "1rem", color: "#9ca3af" }}>No videos yet.</p>
          </div>
        ) : (
          (() => {
            const displayVideos = videos.slice(0, 4);

            return (
              <>
                <style>{`
                .latest-videos-creative .latest-video-thumb {
                  position: relative;
                  width: 100%;
                  /* Taller thumbnail so the 4 cards look bigger */
                  aspect-ratio: 1 / 1;
                  border-radius: 16px;
                  overflow: hidden;
                  background: transparent;
                  cursor: pointer;
                }
                .latest-videos-creative .latest-video-thumb::before{
                  content: "";
                  position: absolute;
                  inset: -60% -40%;
                  background: linear-gradient(115deg,
                    rgba(255,255,255,0) 0%,
                    rgba(255,255,255,0.18) 45%,
                    rgba(255,255,255,0) 70%);
                  transform: rotate(16deg);
                  opacity: 0;
                  animation: latestVideosShine 6.5s ease-in-out infinite;
                  pointer-events: none;
                }
                @keyframes latestVideosShine{
                  0%, 58% { opacity: 0; transform: translateX(-30%) rotate(16deg); }
                  62% { opacity: 1; }
                  100% { opacity: 0; transform: translateX(120%) rotate(16deg); }
                }
                .latest-videos-creative .latest-video-play {
                  width: 52px;
                  height: 52px;
                  border-radius: 50%;
                  background: rgba(0,0,0,0.60);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: #fff;
                  box-shadow: 0 4px 12px rgba(0,0,0,0.35);
                  position: relative;
                }
                .latest-videos-creative .latest-video-play::after{
                  content: "";
                  position: absolute;
                  inset: -10px;
                  border-radius: inherit;
                  border: 1px solid rgba(255,255,255,0.22);
                  animation: latestVideosPulse 2.6s ease-in-out infinite;
                }
                @keyframes latestVideosPulse{
                  0% { transform: scale(0.85); opacity: 0; }
                  25% { opacity: 1; }
                  100% { transform: scale(1.18); opacity: 0; }
                }

                /* Card + CTA (scoped, creative only for Latest Videos) */
                .latest-videos-creative .latest-video-card{
                  position: relative;
                  border: 1px solid rgba(147,197,253,0.28);
                  transition: transform 0.28s ease, filter 0.28s ease;
                  border-radius: 18px !important;
                }
                .latest-videos-creative .latest-video-card::before{
                  content: "";
                  position: absolute;
                  inset: -12px -12px -8px -12px;
                  border-radius: 18px;
                  background:
                    radial-gradient(circle at 20% 0%, rgba(56,189,248,0.38), rgba(56,189,248,0) 55%),
                    radial-gradient(circle at 90% 40%, rgba(167,139,250,0.34), rgba(167,139,250,0) 60%);
                  opacity: 0;
                  transition: opacity 0.28s ease;
                  pointer-events: none;
                  filter: blur(10px);
                  z-index: 0;
                }
                .latest-videos-creative .latest-video-card:hover{
                  transform: translateY(-6px);
                  filter: drop-shadow(0 18px 28px rgba(0,0,0,0.35));
                  border-color: rgba(56,189,248,0.65);
                }
                .latest-videos-creative .latest-video-card:hover::before{
                  opacity: 1;
                }

                .latest-videos-creative .latest-video-card > *{
                  position: relative;
                  z-index: 1;
                }

                .latest-videos-creative .latest-video-thumb{
                  z-index: 1;
                  transform: translateZ(0);
                  transition: transform 0.28s ease, box-shadow 0.28s ease;
                }
                .latest-videos-creative .latest-video-thumb::after{
                  content: "";
                  position: absolute;
                  inset: 0;
                  background: linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,0.66) 100%);
                  opacity: 0.9;
                  transition: opacity 0.28s ease;
                  pointer-events: none;
                }
                .latest-videos-creative .latest-video-card:hover .latest-video-thumb{
                  transform: translateY(-3px) scale(1.02);
                  box-shadow: 0 18px 40px rgba(0,0,0,0.32);
                }
                .latest-videos-creative .latest-video-card:hover .latest-video-thumb::after{
                  opacity: 1;
                }

                .latest-videos-creative .latest-video-cta{
                  position: relative;
                  z-index: 1;
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  padding: 12px 22px;
                  border-radius: 999px;
                  background: linear-gradient(135deg, rgba(56,189,248,0.18), rgba(167,139,250,0.14));
                  border: 1px solid rgba(147,197,253,0.40);
                  color:rgb(0, 0, 0);
                  font-weight: 600;
                  letter-spacing: 0.02em;
                  text-decoration: none;
                  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, background 0.2s ease;
                }
                .latest-videos-creative .latest-video-cta::before{
                  content: "";
                  position: absolute;
                  inset: -2px;
                  border-radius: inherit;
                  background: linear-gradient(90deg, rgba(56,189,248,0), rgba(56,189,248,0.60), rgba(167,139,250,0.55), rgba(56,189,248,0));
                  opacity: 0;
                  transition: opacity 0.2s ease;
                  z-index: -1;
                  filter: blur(10px);
                }
                .latest-videos-creative .latest-video-cta:hover{
                  transform: translateY(-2px);
                  box-shadow: 0 16px 30px rgba(0,0,0,0.35);
                  border-color: rgba(56,189,248,0.65);
                  background: linear-gradient(135deg, rgba(56,189,248,0.28), rgba(167,139,250,0.20));
                }
                .latest-videos-creative .latest-video-cta:hover::before{
                  opacity: 1;
                }
                .latest-videos-creative .latest-video-cta:focus-visible{
                  outline: 2px solid rgba(56,189,248,0.70);
                  outline-offset: 3px;
                }

                /* Showcase grid (no slider/carousel) */
                .latest-videos-grid{
                  width: 100%;
                  max-width: 1400px;
                  margin: 0 auto;
                  display: grid;
                  grid-template-columns: repeat(1, minmax(0, 1fr));
                  gap: 22px;
                  justify-items: stretch;
                  align-items: stretch;
                }

                @media (min-width: 768px) {
                  .latest-videos-grid{
                    grid-template-columns: repeat(2, minmax(0, 1fr));
                  }
                }

                @media (min-width: 992px) {
                  .latest-videos-grid{
                    grid-template-columns: repeat(4, minmax(0, 1fr));
                  }
                }
              `}</style>
                <div className="latest-videos-grid">
                  {displayVideos.map((video, index) => {
                  const isUploaded = (video.url || "").startsWith("/uploads/videos/");
                  const videoSrc = getVideoSrc(video.url);
                  // Use the same thumbnail field that is saved in the database
                  const thumbSrc = imageSrc(video.thumbnail || "");
                  const isPlaying = playingId === video._id;
                  return (
                      <div
                        key={`${video._id}-${index}`}
                        className="category-card latest-video-card"
                        style={{
                          width: "100%",
                          borderRadius: 0,
                          overflow: "visible",
                          background: "transparent",
                          padding: 0,
                          display: "flex",
                          flexDirection: "column",
                          gap: "0.75rem",
                        }}
                      >
                        <div
                          className="box-img global-img latest-video-box"
                          style={{
                            borderRadius: 16,
                            overflow: "hidden",
                            backgroundColor: "transparent",
                          }}
                        >
                          {isPlaying && isUploaded ? (
                            <video
                              src={videoSrc}
                              controls
                              autoPlay
                              preload="metadata"
                              playsInline
                              style={{
                                width: "100%",
                                aspectRatio: "1/1",
                                objectFit: "cover",
                                borderRadius: 16,
                              }}
                            >
                              Your browser does not support the video tag.
                            </video>
                          ) : (
                            <div
                              className="latest-video-thumb"
                              onClick={() => {
                                if (isUploaded) {
                                  setPlayingId(video._id);
                                } else if (video.url) {
                                  window.open(video.url, "_blank", "noopener");
                                }
                              }}
                            >
                              {thumbSrc ? (
                                <img
                                  src={thumbSrc}
                                  alt={video.title}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#fff",
                                    fontSize: 13,
                                    opacity: 0.8,
                                  }}
                                >
                                  {isUploaded ? "Click to play video" : "Click to open video"}
                                </div>
                              )}
                              <div
                                style={{
                                  position: "absolute",
                                  inset: 0,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background:
                                    "radial-gradient(circle at center, rgba(0,0,0,0.1), rgba(0,0,0,0.55))",
                                  pointerEvents: "none",
                                }}
                              >
                                <div className="latest-video-play">
                                  <i className="far fa-play" style={{ marginLeft: 3, fontSize: 20 }} />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        <div
                          style={{
                            marginTop: "0.5rem",
                            textAlign: "center",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "100%",
                            }}
                          >
                            <span
                              className="latest-video-category"
                              style={{
                                fontSize: "0.78rem",
                                letterSpacing: "0.09em",
                                textTransform: "uppercase",
                                color: "#000000",
                                textShadow: "none",
                                display: "block",
                                marginBottom: "0.2rem",
                              }}
                            >
                              {categoryLabel(video.category)}
                            </span>
                          </div>
                        </div>
                        <a
                          className="line-btn latest-video-cta"
                          href={video.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            marginTop: "0.75rem",
                            marginBottom: "10px",
                            alignSelf: "center",
                            textAlign: "center",
                          }}
                        >
                          Watch video
                        </a>
                      </div>
                  );
                })}
                </div>
              </>
            );
          })() ) }
      </div>
    </section>
  );
};

export default CategoryOne;
